import React, { useEffect, useState } from 'react'
import { Slider } from '@mui/material'
import '../../../../css/dateRangeSlider.css'

export interface SoloRangeSliderProps {
    min: number
    max: number
    onChange: (min: number, max: number) => void
    type: string
}

export const SoloRangeSlider: React.FC<SoloRangeSliderProps> = ({ min, max, onChange, type }) => {
    const [minVal, setMinVal] = useState(min)
    const [maxVal, setMaxVal] = useState(max)

    useEffect(() => {
        onChange(minVal, maxVal)
    }, [minVal, maxVal])

    const handleSliderChange = (event: Event, newValue: number | number[]) => {
        if (type === "on") {
            const singleValue = Array.isArray(newValue) ? newValue[0] : newValue;
            setMinVal(singleValue);
            setMaxVal(singleValue);
        } else if (type === "after") {
            const singleValue = Array.isArray(newValue) ? newValue[0] : newValue;
            setMinVal(singleValue);
            setMaxVal(max);
        } else if (type === "before") {
            const singleValue = Array.isArray(newValue) ? newValue[0] : newValue;
            setMinVal(min);
            setMaxVal(singleValue);
        } else {
            if (Array.isArray(newValue)) {
                setMinVal(newValue[0]);
                setMaxVal(newValue[1]);
            }
        }
    };

    const getSliderValue = () => {
        if (type === "on") {
            return minVal;
        } else if (type === "after") {
            return minVal;
        } else if (type === "before") {
            return maxVal;
        } else {
            return [minVal, maxVal];
        }
    };

    return (
        <div className="container">
            <Slider
                value={getSliderValue()}
                onChange={handleSliderChange}
                min={min}
                max={max}
                valueLabelDisplay="auto"
                marks={[
                    {
                        value: min,
                        label: min
                    },
                    {
                        value: max,
                        label: max
                    }
                ]}
            />
        </div>
    )
}

export default SoloRangeSlider
